import request from './request'

const defaults = {
  vehicle_plate_color: [{ label: '蓝色', value: 1 }, { label: '黄色', value: 2 }, { label: '黄绿', value: 3 }],
  waybill_status: [{ label: '待开始', value: 0 }, { label: '运输中', value: 1 }, { label: '已完成', value: 2 }, { label: '已作废', value: 3 }, { label: '运单监控结束', value: 4 }]
}

export function defaultBusinessOptions(code) {
  return (defaults[code] || []).map(item => ({ ...item }))
}

export async function loadBusinessOptions(code) {
  if (!Object.prototype.hasOwnProperty.call(defaults, code)) throw new Error('不支持的业务字典')
  const response = await request.get('/webserver/system/dictionaries/options', { params: { code } })
  if (!Array.isArray(response.data)) throw new Error('业务字典响应格式错误')
  const allowed = new Set(defaults[code].map(item => String(item.value)))
  // 固定业务状态码范围；管理员新增未知字典值不能改变车辆或运单业务契约。
  return response.data.filter(item => item && Number(item.status) === 1 && allowed.has(String(item.value)))
    .map(item => ({ label: item.label, value: Number(item.value), sortOrder: Number(item.sortOrder) || 0 }))
    .sort((first, second) => first.sortOrder - second.sortOrder)
}

export function businessOptionLabel(code, options, value) {
  const active = options.find(item => item.value === Number(value))
  if (active) return active.label
  const previous = (defaults[code] || []).find(item => item.value === Number(value))
  return previous ? `${previous.label}（已停用）` : '-'
}
